import React, { useState, useEffect } from "react";
import "./style.less";
import { List, Button, Grid, Icon } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import {
  setSelectedVertex,
  setToPublishFence
} from "../../../../../redux/geofence/actions";
import { Element, scroller } from "react-scroll";
import { removeVertextFromGeoJSONPolygon } from "../../../GeofenceDraw/utils";

function FenceCoordsList() {
  const fence = useSelector(({ geofence }) => geofence.toPublishFence);
  const selectedVertex = useSelector(({ geofence }) => geofence.selectedVertex);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    scroller.scrollTo(selectedVertex + "_coord", {
      duration: 1200,
      delay: 100,
      smooth: true,
      containerId: "CoordsScrollToContainer"
    });
  }, [selectedVertex]);

  const showDeleteConfirmBox = index => {
    setShowConfirmation(index);
    setSelectedVertex(index);
  };
  const hideDeleteConfirmBox = index => {
    setShowConfirmation(false);
    setSelectedVertex(index);
  };

  const deleteVertex = index => {
    const updatedFence = removeVertextFromGeoJSONPolygon(index, fence);
    dispatch(setToPublishFence(updatedFence));
  };

  return (
    <div id="CoordsScrollToContainer" className="FenceCoordsList">
      <List divided verticalAlign="middle">
        {fence
          ? fence.geometry.coordinates.map(path =>
              path.map((coord, index) => {
                if (index === path.length - 1) return null;
                return (
                  <Element name={index + "_coord"} key={index}>
                    <List.Item>
                      <List.Content>
                        <Grid>
                          <Grid.Row
                            onClick={() => dispatch(setSelectedVertex(index))}
                            className="coords-container"
                          >
                            <Grid.Column width={2}>
                              <div
                                className={`coord-num ${
                                  selectedVertex === index ? "active" : ""
                                }`}
                              >
                                {index}
                              </div>
                            </Grid.Column>
                            <Grid.Column
                              width={12}
                              className="coord-text"
                            >{`${coord[1]}, ${coord[0]}`}</Grid.Column>
                            <Grid.Column width={2}>
                              <Icon
                                onClick={() => showDeleteConfirmBox(index)}
                                className="delete-vertex-cta"
                                name="trash alternate outline"
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row
                            className={`confirm ${
                              showConfirmation === index ? "active" : ""
                            }`}
                            columns={2}
                          >
                            <Grid.Column>
                              <Button
                                onClick={() => {
                                  deleteVertex(index);
                                }}
                                fluid
                                className="confirm-delete"
                              >
                                Yes, Delete
                              </Button>
                            </Grid.Column>
                            <Grid.Column>
                              <Button
                                onClick={() => hideDeleteConfirmBox(index)}
                                fluid
                                className="cancel-delete"
                              >
                                No, Cancel
                              </Button>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </List.Content>
                    </List.Item>
                  </Element>
                );
              })
            )
          : null}
      </List>
    </div>
  );
}

export default FenceCoordsList;
